import StorefrontView from './StorefrontView';
import Locations from './locations';

export default {
  StorefrontView,
  Locations,
};
